import POSPage from '@/pages/POSPage'

export default function CocinaPage() {
  return <POSPage view="kitchen" />
}

